// extracted by css-extract-rspack-plugin
export default {"FilterFooterRoot":"FeGdo"};